import React, {PropTypes} from 'react';
import TocArticleEl from './TocArticleEl';

const TocEl = props => {
  let {el, children} = props;
  let level = (el.level < 7 && el.level > 0) ? el.level : el.level;
  let className = 'structure-toc-heading structure-toc-level-' + level;
  if (el.type === 'articles') {
    return (<TocArticleEl articles={el.articles} level={el.level}/>);
  }
  else {
    switch (el.level) {
      case 1:
        return <div className={className}><p><strong>{el.body}</strong>{children}</p></div>;
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
        return <div className={className}><p>{el.body}{children}</p></div>;
      default:
        return <div className={className}><p>{el.body}{children}</p></div>;
    }
  }
};

TocEl.propTypes = {
  el: PropTypes.object.isRequired,
  children: PropTypes.node
};

export default TocEl;



/** WEBPACK FOOTER **
 ** ./src/modules/structures/components/TocEl.js
 **/